/* eslint-disable react-refresh/only-export-components, react-hooks/set-state-in-effect */
import { createContext, useContext, useEffect, useState } from 'react'
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom'
import { api } from '../lib/api'

export type Workspace = { business: { id: string; name: string }; membership?: { role: string }; role?: string; main_branch?: { id: string; name: string } | null }
type User = { id: string; full_name: string | null; email: string }
type AuthValue = { user: User; workspace: Workspace; businesses: Workspace[]; refresh: () => Promise<void> }
const AuthContext = createContext<AuthValue | null>(null)
export const useAuth = () => { const value = useContext(AuthContext); if (!value) throw new Error('Auth context unavailable'); return value }

export function ProtectedRoute() {
  const navigate = useNavigate(); const location = useLocation()
  const [state, setState] = useState<{ user: User; workspace: Workspace; businesses: Workspace[] } | null>(null)
  const [failed, setFailed] = useState(false)
  const refresh = async () => {
    const user = await api<User>('/api/auth/me')
    const result = await api<{ businesses: Workspace[] }>('/api/businesses/my-businesses')
    if (!result.businesses.length) { navigate('/onboarding', { replace: true }); return }
    let id = localStorage.getItem('aad_selected_business_id')
    if (result.businesses.length === 1) id = result.businesses[0].business.id
    if (!id || !result.businesses.some((item) => item.business.id === id)) { navigate('/select-workspace', { replace: true }); return }
    localStorage.setItem('aad_selected_business_id', id)
    const workspace = await api<Workspace>(`/api/businesses/${id}/workspace`)
    setState({ user, workspace, businesses: result.businesses })
  }
  useEffect(() => { if (!localStorage.getItem('aad_access_token')) { setFailed(true); return }; void refresh().catch(() => setFailed(true)) }, [location.key])
  if (failed) return <Navigate to="/login" replace />
  if (!state) return <main className="aad-state"><strong>Opening your workspace…</strong></main>
  return <AuthContext.Provider value={{ ...state, refresh }}><Outlet /></AuthContext.Provider>
}

export function PlatformAdminRoute() {
  const [state, setState] = useState<'loading' | 'allowed' | 'forbidden'>('loading')
  useEffect(() => {
    api<{ permissions: string[] }>('/api/admin/me')
      .then((result) => setState(result.permissions.includes('platform.view') ? 'allowed' : 'forbidden'))
      .catch(() => setState('forbidden'))
  }, [])
  if (state === 'loading') return <main className="aad-state"><strong>Opening AAD Platform Admin…</strong></main>
  if (state === 'forbidden') return <main className="aad-state aad-state-error"><strong>403 Forbidden</strong><p>You do not have access to Platform Administration.</p></main>
  return <Outlet />
}
